import { useQuery } from "react-query";

import { useOrg, useTimeLookbackRange } from "@hooks";

import { fetchDeploymentSummaryStats } from "../api";

export const useDeploymentSummaryStats = (reposFilter: string[]) => {
  const org = useOrg();
  const { tlr } = useTimeLookbackRange();

  return useQuery(
    ["DeploymentSummaryStats", org, tlr, reposFilter],
    () => fetchDeploymentSummaryStats(org!.id, tlr, reposFilter),
    {
      enabled: !!org,
    }
  );
};
